<template>
  <v-table
    :count="count"
    :list="list"
    :is-loading="isLoading"
    :push-list="RouteConfig.cardDeletedList.push"
    :query-list="queryList"
    :is-show-store-select="true"
    :is-store-select-clearable="true"
    :is-show-search-input="true"
    :is-show-xls-export-button="true"
    excel-name="退卡记录列表"
    :excel-data="xlsData"
  >
    <template slot="header-item">
      <div class="flex-align-center flex-wrap table-filter-item">
        <div class="flex-align-center table-filter-label">仅显示录入错误：</div>
        <el-switch
          v-model="queryList.is_input_error"
          :active-value="1"
          :inactive-value="0"
          @change="handleInputErrorChange"
        />
      </div>
    </template>

    <v-column-time value="退卡通过时间"/>
    <el-table-column label="课卡名称" prop="card_name" width="150"/>
    <v-column-student label="所属学员" link-page-id="student_id"/>
    <el-table-column label="办卡门店" prop="store_name" width="150"/>
    <v-column-avatar
      label="申请人"
      avatar-key="apply_administrator_avatar"
      nickname-key="apply_administrator_nickname"
    />
    <v-column-avatar
      label="审核人"
      avatar-key="examine_administrator_avatar"
      nickname-key="examine_administrator_nickname"
    />
    <el-table-column label="退款金额" align="center">
      <template v-slot="{row}">{{ row.del_payment | toYuan }}</template>
    </el-table-column>
    <el-table-column label="退卡原因" prop="del_remark"/>
    <el-table-column label="录入错误" width="90" align="center">
      <template v-slot="{ row }">
        <el-tag v-if="row.is_input_error" type="danger" size="small">是</el-tag>
        <el-tag v-else type="info" size="small">否</el-tag>
      </template>
    </el-table-column>
    <el-table-column label="原因截图">
      <template v-slot="{ row }">
        <el-image
          v-if="row.del_cover"
          :src="row.del_cover"
          style="width: 60px;height: 60px;"
          fit="cover"
        />
      </template>
    </el-table-column>

    <v-column-time value="失效日期" field="expire_time" time-format="timeToYmdHi" empty-tip="-" sortable="" align="center"/>
    <el-table-column label="剩余次数" align="center">
      <template v-slot="{ row }">
        <span v-if="row.is_number_limit">{{ row.expire_number | toYuan }}</span>
        <span v-else class="success-color">无限制</span>
      </template>
    </el-table-column>

    <el-table-column label="操作" width="244px">
      <template v-slot="{ row }">
        <v-list-button :to="RouteConfig.cardDeleteRecordEdit.to(row.id)"/>

        <v-list-button name="查看" icon="browse" :to="RouteConfig.cardDeleteRecordDetail.to(row.id)"/>
      </template>
    </el-table-column>

    <template slot="mobile-list">
      <section class="list">
        <template v-if="list.length">
          <div
            v-for="(v, k) in list"
            :key="`card-list-${k}-${v.id}`"
            class="list-item primary-background-light"
          >
            <div class="list-item-detail">
              <span>所属学员</span>

              <v-avatar-nickname
                :value="v.selfie"
                :nickname="v.student_name"
                :is-center="true"
                :link-page-name="RouteConfig.studentDetail.name"
                :link-page-id="v.student_id"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>申请人</span>

              <v-avatar-nickname
                :value="v.apply_administrator_avatar"
                :nickname="v.apply_administrator_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>审核人</span>

              <v-avatar-nickname
                :value="v.examine_administrator_avatar"
                :nickname="v.examine_administrator_nickname"
                :is-center="true"
                :avatar-size="50"
                width="30vw"
              />
            </div>

            <div class="list-item-detail">
              <span>退卡通过时间</span>

              <span>{{ v.add_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>课卡名称</span>

              <span>{{ v.card_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>办卡门店</span>

              <span>{{ v.store_name || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>退款金额</span>

              <span>{{ v.del_payment || 0 }}</span>
            </div>

            <div class="list-item-detail">
              <span>退卡原因</span>

              <span>{{ v.del_remark || '' }}</span>
            </div>

            <div class="list-item-detail">
              <span>录入错误</span>

              <el-tag v-if="v.is_input_error" type="danger" size="small">是</el-tag>

              <el-tag v-else type="info" size="small">否</el-tag>
            </div>

            <div class="list-item-detail">
              <span>失效日期</span>

              <span>{{ v.expire_time | timeToYmdHi }}</span>
            </div>

            <div class="list-item-detail">
              <span>剩余次数</span>

              <span v-if="v.is_number_limit">{{ v.expire_number | toYuan }}</span>

              <span v-else class="success-color">无限制</span>
            </div>

            <div class="list-item-button">
              <v-list-button :to="RouteConfig.cardDeleteRecordEdit.to(v.id)"/>

              <v-list-button name="查看" icon="browse" :to="RouteConfig.cardDeleteRecordDetail.to(v.id)"/>
            </div>
          </div>
        </template>

        <v-empty :is-loading="isLoading" :length="list.length"/>
      </section>
    </template>
  </v-table>
</template>

<script>
import RouteConfig from '@/router/config';
import { mapGetters } from 'vuex';
import { index } from '@/api/card-del-record';
import { getLegalQueryList } from '@/utils/formats';
import { timeToYmd, timeToYmdHi, toYuan } from "@/filters";

export default {
  name: RouteConfig.cardDeletedList.name,
  data: () => ({
    RouteConfig,
    isLoading: false,
    count: 0,
    list: [],
    xlsData: [],
    isStoringIds: [],
    queryList: {
      is_input_error: 0,
    },
  }),
  watch: {
    '$route'(to) {
      this.load(to);
    },
  },
  computed: {
    ...mapGetters([
      'isMobile',
      'isAdministrator',
      'defaultStoreId',
    ]),
  },
  beforeMount() {
    this.load();
  },
  methods: {
    refresh() {
      RouteConfig.cardDeletedList.push(this.queryList);
    },
    handleStoreChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handleInputErrorChange() {
      this.queryList.page = 1;
      this.refresh();
    },
    handlePageChange({ page, size }) {
      this.queryList.page = page;
      this.queryList.size = size;
      this.refresh();
    },
    async load(route = this.$route) {
      const { queryList } = this;
      queryList.store_id = this.defaultStoreId;
      getLegalQueryList(queryList, route.query);

      const { ...params } = queryList;
      params.is_del = 1;

      this.isLoading = true;
      const { isError, data } = await index(params);
      this.isLoading = false;
      if (isError) return;

      const xlsData = [];
      data.list.forEach(item => {
        xlsData.push({
          '课卡ID': item.id,
          '添加时间': timeToYmdHi(item.add_time),
          '退卡时间': timeToYmdHi(item.is_del),
          '退卡管理员': item.administrator_nickname,
          '退卡原因': item.del_remark,
          '录入错误': item.is_input_error ? '是' : '否',
          '退卡原因截图': item.del_cover,
          '退款金额': toYuan(item.del_payment),
          '办卡日期': timeToYmd(item.register_time),
          '开卡时间': timeToYmdHi(item.start_time, '未开卡'),
          '办卡门店': item.store_name,
          '所属学员': item.student_name,
          '课卡名称': item.card_name,
          '课卡类型': item.card_type_name,
          '有效天数': item.expire_days,
          '失效日期': timeToYmdHi(item.expire_time, '未开卡'),
          '剩余次数': item.is_number_limit ? toYuan(item.expire_number) : '-',
          '是否可用': item.is_reviewing ? '已锁定' : '可使用',
          '实际付款': toYuan(item.actual_payment),
          '未消费金额': toYuan(item.not_consumed_amount),
        });
      });

      this.count = data.count;
      this.list = data.list;
      this.xlsData = xlsData;
    },
  },
};
</script>
